export const modalCloseButtonHandler = {
	selector: {
		button: 'data-modal-close',
	},
}
